import { defineStore } from 'pinia'

interface ModalState {
  showBetslip: boolean
  showFavorites: boolean
  showCheckout: boolean
}

export const useModalStore = defineStore('modal', {
  state: (): ModalState => ({
    showBetslip: false,
    showFavorites: false,
    showCheckout: false
  }),

  actions: {
    openBetslip() {
      this.showBetslip = true
    },
    closeBetslip() {
      this.showBetslip = false
    },
    openFavorites() {
      this.showFavorites = true
    },
    closeFavorites() {
      this.showFavorites = false
    },
    openCheckout() {
      this.showCheckout = true
    },
    closeCheckout() {
      this.showCheckout = false
    }
  }
}) 